import React, { useEffect, useState } from 'react';
import {
 Chart as ChartJS,
 CategoryScale,
 LinearScale,
 BarElement,
 PointElement,
 LineElement,
 Title,
 Tooltip,
 Legend
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar, Chart } from "react-chartjs-2";
ChartJS.register(
 CategoryScale,
 LinearScale,
 BarElement,
 PointElement,
 LineElement,
 Title,
 Tooltip,
 Legend,
 ChartDataLabels
);
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Row,
    CardHeader,
    Button,
    Nav,
    NavItem,
    NavLink,
} from 'reactstrap';
import ErrorBoundary from 'components/ErrorBoundary';
import Drawer from 'components/Drawer';
import Scripts100livesDrawer from '../GridData/Scripts100livesDrawer';
 
const Scripts100lives = ({scriptsby100LivesData,searchData}) => {
  const [isOpen, setIsOpen] = useState(false);
      const [disabledViewButtom, setDisabledViewButtom] = useState(true);
  
 useEffect(() => {
    if (scriptsby100LivesData[0]?.membersCount!=null||scriptsby100LivesData[0]?.netPaidClaimsCount!=null||scriptsby100LivesData[0]?.scriptsbyMembers ) {
      setDisabledViewButtom(false);
    } else {
      setDisabledViewButtom(true);
    }
  }, [scriptsby100LivesData]);
  const chartData = {
 labels:scriptsby100LivesData[0]?.labels, 
   datasets: [
     {
       type: 'bar',
       label: 'Net Paid Claims',
       data:scriptsby100LivesData[0]?.netPaidClaimsCount,
       backgroundColor: 'rgba(128, 0, 128, 0.7)', 
       borderColor: 'rgba(128, 0, 128, 1)',
       borderWidth: 1,
      
     },
    //  {
    //    type: 'bar',
    //    label: 'Rejected Claims',
    //    data: scriptsby100LivesData[0]?.rejectedClaimsCount,
    //    backgroundColor: 'rgba(0, 128, 0, 0.7)', 
    //    borderColor: 'rgba(0, 128, 0, 1)',
    //    borderWidth: 1,
    //    fill: true,
        
    //  },
     {
       type: 'line',
       label: 'Script/1000 Members',
       data:scriptsby100LivesData[0]?.scriptsbyMembers,
      backgroundColor: 'rgba(128, 0, 77, 0.5)', 
       borderColor: 'rgba(128, 0, 64, 1)',
       fill: false,
    //    datalabels:{
    //     display:true,
    //         anchor:'bottom',
    //  align:'bottom',
    //          }
      datalabels: {
                    display: false,
                    align: function (context) {
                        return context.dataset.data[context.dataIndex] < 150000
                            ? 'nearest'
                            : 'nearest';
                    },
                    color: function (context) {
                        return context.dataset.data[context.dataIndex] < 150000
                            ? 'black'
                            : 'black';
                    },
                    anchor: 'end',
                    padding: {
                        right: 2,
                    },
                    labels: {
                        padding: { top: 10 },
                        value: {
                            color: '#2B3346',
                        },
                    },
                    formatter: function(value) {
      const strVal = value.toString();
      const decimalPart = strVal.split('.')[1];
      if (decimalPart && decimalPart.length > 2) {
        return parseFloat(value).toFixed(2);
      }
      return value;
    }
                  },
    
     },
     {
       type: 'line',
       label: 'Membership',
       data:scriptsby100LivesData[0]?.membersCount,
      backgroundColor: 'rgba(75, 0, 130, 0.5)', 
       borderColor: 'rgba(75, 0, 130, 1)',
    //    fill: false,
    //        datalabels:{
    //     display:true,
    //         anchor:'start',
    //  align:'end',
    //          }
      datalabels: {
                    display: false,
                    align: function (context) {
                        return context.dataset.data[context.dataIndex] < 150000
                            ? 'start'
                            : 'end';
                    },
                    color: function (context) {
                        return context.dataset.data[context.dataIndex] < 150000
                            ? 'black'
                            : 'black';
                    },
                    anchor: 'end',
                    padding: {
                        right: 2,
                    },
                    labels: {
                        padding: { top: 10 },
                        value: {
                            color: '#2B3346',
                        },
                    },
                    
formatter: function(value) {
      const strVal = value.toString();
      const decimalPart = strVal.split('.')[1];
      if (decimalPart && decimalPart.length > 2) {
        return parseFloat(value).toFixed(2);
      }
      return value;
    }
                  },
     },
   ],
 };
 
 const options = {
   responsive: true,
   plugins: {
     legend: {
       position: 'bottom', 
          labels: {
                        padding: 15,
                        usePointStyle: true,
                        pointStyle: 'rect',
                        color: '#707070',
                        font: {
                            weight: 'bold',
                        },
                    },
                      align: 'start',
     },
     title: {
       display: true,
      // text: 'Scripts/1000 Lives',
     },
     datalabels:{
    display:false,
     },
       tooltip: {
        mode: 'index',
        intersect: false,
      },
     
    //  formatter:(value,context)=>{
    //     if(context.dataset.type=='bar'){
    //         return value;
    //     }
    //     return null
    //  },
   
   },
   scales: {
    x:{
        stacked:true
    },
     y: {
       beginAtZero: true,
      stacked: false,
     },
   },
 };
 const handleActive = (title) => {
        setActive(title);
    };
    const getDate = () => {
        setActive('custom')
    }
    const handleProceed = () => {
        setIsOpen(!isOpen);
    }
    const onHandleIsOpen = (hasRefresh) => {
        if (isBoolean(hasRefresh) && hasRefresh) {
            onClose(true);
        }
        setIsOpen(!isOpen)
    }
 return (
    <div>
      <ErrorBoundary>
             <Card className='p-3 h-100'>
            <CardHeader className='border-0 bg-white px-0 pt-0'>
           <Row className="align-items-center">
           <Col>
           <CardTitle className="f-20 font-weight-500">Scripts/1000 Lives </CardTitle>
           </Col>
          </Row>
         </CardHeader>
            <CardBody className='dashboard-chart-body'>
          
             <Bar type="bar" data={chartData} options={options} />
               <div className="view-report">
                        <Button
                            color='primary'
                            className='ms-2'
                            onClick={handleProceed}
                            style={{ float: "right", position: "absolute", bottom: "3px", right: "30px"}}
                            disabled={disabledViewButtom}
                        >
                            View Report
                        </Button>
                    </div>
            </CardBody>
          </Card>
             <Drawer
                direction='end'
                title='Scripts/1000 Lives'
                isOpen={isOpen}
                toggle={handleProceed}
                size="lg"
            >
                <Scripts100livesDrawer searchData={searchData}  onHandleIsOpen={onHandleIsOpen}  />
            </Drawer>
          </ErrorBoundary>
    </div>
 )
 

};
export default Scripts100lives;